"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var StackHeaderBackButton_exports = {};
__export(StackHeaderBackButton_exports, {
  StackHeaderBackButton: () => StackHeaderBackButton,
  appendStackHeaderBackButtonPropsToOptions: () => appendStackHeaderBackButtonPropsToOptions
});
module.exports = __toCommonJS(StackHeaderBackButton_exports);
var import_children = require("../../headless/children");
function StackHeaderBackButton(_props) {
  return null;
}
Object.assign(StackHeaderBackButton, {
  [import_children.NAVIGATOR_CONFIG]: true
});
function appendStackHeaderBackButtonPropsToOptions(options, props) {
  return {
    ...options,
    headerBackTitle: props.children,
    headerBackTitleStyle: props.style,
    headerBackIcon: props.src ? {
      type: "image",
      source: props.src
    } : void 0,
    headerBackButtonDisplayMode: props.displayMode,
    headerBackButtonMenuEnabled: props.withMenu,
    headerBackVisible: props.hidden !== void 0 ? !props.hidden : void 0
  };
}
//# sourceMappingURL=StackHeaderBackButton.js.map
